import { CommonDetails, Enrollment } from "../../../@types/enrollment.types";
import { EnrollmentSchema } from "../../../@types/enrollment.types copy";

export const getCommonDetails = (enrollment: Enrollment): CommonDetails => {
	const {
		agent_id,
		location_number,
		location_name,
		group_number,
		group_name,
		plan_object_id,
		plan_code,
		plan_name,
		base_plan_name,
		insured_object_id,
		insured_SSN,
		writing_number,
		premium_amount,
		total_premium,
		unenrolled_reason,
		waive_reason,
		termination_reason,
		enrollment_date,
		effective_date,
		termination_date,
		open_enrollment_id,
		sub_plan
	} = enrollment;
	const commonDetails: CommonDetails = {
		agent_id,
		location_number,
		location_name,
		group_number,
		group_name,
		plan_object_id,
		plan_code,
		plan_name,
		base_plan_name,
		sub_plan: sub_plan || undefined,
		insured_object_id,
		insured_SSN,
		premium_amount,
		writing_number,
		total_premium,
		unenrolled_reason,
		waive_reason,
		termination_reason,
		enrollment_date: enrollment_date as unknown as string,
		effective_date: effective_date as unknown as string,
		termination_date: termination_date as unknown as string,
		open_enrollment_id
	};
	return commonDetails;
};
